import React from "react";
import { motion } from "framer-motion";
import { Box, Typography, Grid } from "@mui/material";
import FavoriteRoundedIcon from "@mui/icons-material/FavoriteRounded";
import TrackChangesRoundedIcon from "@mui/icons-material/TrackChangesRounded";
import SEO from "../components/seo/SEO";

const doctors = [
  { name: "Dr. Aisha Patel", specialty: "Internal Medicine", initials: "AP" },
  { name: "Dr. Vikram Sharma", specialty: "Cardiology", initials: "VS" },
  { name: "Dr. Priya Menon", specialty: "Mental Health", initials: "PM" },
  { name: "Dr. Rajesh Kumar", specialty: "Pediatrics", initials: "RK" }
];

export default function About() {
  return (
    <>
      <SEO
        title="About Us"
        description="Learn about Rite Wellness - India's trusted concierge healthcare provider with 200+ expert doctors and 50,000+ happy patients."
        canonical="/about"
      />
      <Box component="main" sx={{ pt: "96px" }}>
        <Box component="section" className="section-padding wellness-bg">
          <Box className="container-custom">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              style={{ textAlign: "center", maxWidth: 768, margin: "0 auto 64px" }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "2.25rem", md: "3rem" },
                  fontWeight: 700,
                  mb: 3,
                  lineHeight: 1.1
                }}
              >
                Redefining Healthcare
                <Box component="span" className="gradient-text" sx={{ display: "block" }}>
                  For Modern Bloomington, Indiana
                </Box>
              </Typography>
              <Typography sx={{ fontSize: "1.125rem", color: "text.secondary" }}>
                We combine world-class medical expertise with technology to make quality healthcare
                accessible, personal, and preventive.
              </Typography>
            </motion.div>

            <Grid container spacing={6}>
              <Grid item xs={12} md={6}>
                <Box className="glass-card" sx={{ p: 4 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "16px",
                      bgcolor: "rgba(39,165,153,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2
                    }}
                  >
                    <TrackChangesRoundedIcon sx={{ color: "primary.main", fontSize: 28 }} />
                  </Box>
                  <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 2 }}>
                    Our Mission
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    To provide accessible, preventive, and affordable healthcare that empowers every
                    individual to live their healthiest life.
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6}>
                <Box className="glass-card" sx={{ p: 4 }}>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "16px",
                      bgcolor: "rgba(57,172,130,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2
                    }}
                  >
                    <FavoriteRoundedIcon sx={{ color: "#39ac82", fontSize: 28 }} />
                  </Box>
                  <Typography sx={{ fontSize: "1.5rem", fontWeight: 700, mb: 2 }}>
                    Our Vision
                  </Typography>
                  <Typography sx={{ color: "text.secondary" }}>
                    To become Bloomington, Indiana's most trusted wellness partner, transforming how families
                    experience and manage their health.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <Box component="section" className="section-padding">
          <Box className="container-custom">
            <Typography sx={{ fontSize: "1.875rem", fontWeight: 700, textAlign: "center", mb: 6 }}>
              Meet Our Doctors
            </Typography>

            <Grid container spacing={3}>
              {doctors.map((doc, i) => (
                <Grid item xs={12} sm={6} lg={3} key={doc.name}>
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 }}
                  >
                    <Box className="premium-card" sx={{ p: 3, textAlign: "center" }}>
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          bgcolor: "rgba(39,165,153,0.1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mx: "auto",
                          mb: 2,
                          fontSize: "1.25rem",
                          fontWeight: 700,
                          color: "primary.main"
                        }}
                      >
                        {doc.initials}
                      </Box>
                      <Typography sx={{ fontWeight: 600 }}>{doc.name}</Typography>
                      <Typography sx={{ fontSize: "0.875rem", color: "text.secondary" }}>
                        {doc.specialty}
                      </Typography>
                    </Box>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}
